module.exports = __webpack_public_path__ + "img/buseturker.3b8810e0.jpeg";